<template>
  <div class="contact-form">
    <!-- 联系人表单 -->
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :disabled="status === 1"
      label-width="180px"
      class="demo-ruleForm"
      size="mini"
      inline-message
    >
      <!-- 联系人姓名 -->
      <el-form-item label="联系人姓名：" prop="contactUsername" :error="errorMsg.contactUsername">
        <el-input
          v-model="ruleForm.contactUsername"
          :disabled="status === 1"
          placeholder="请输入姓名"
          @input="_limitLen(undefined, undefined, 'contactUsername', 30)"
        ></el-input>
        <div v-show="reasons.contactUsername" class="reason">驳回原因：{{ reasons.contactUsername }}</div>
      </el-form-item>

      <el-form-item>
        <div class="download-tips">
          请确保填写的<span class="highlight">联系人姓名</span>、<span class="highlight">联系人手机</span>、<span class="highlight">联系人身份证号</span>均为同一个人，否则有<span class="highlight">认证风险</span>。
          <!-- 请确保填写的<span class="highlight">联系人姓名</span>与您的<span class="highlight">身份证</span>完全一致，否则有<span class="highlight">认证风险</span>。 -->
        </div>
      </el-form-item>

      <!-- 职位 -->
      <el-form-item label="职位：" prop="contactPosition" :error="errorMsg.contactPosition">
        <el-input
          v-model="ruleForm.contactPosition"
          :disabled="status === 1"
          placeholder="请输入职位"
          @input="_limitLen(undefined, undefined, 'contactPosition', 30)"
        ></el-input>
        <div v-show="reasons.contactPosition" class="reason">驳回原因：{{ reasons.contactPosition }}</div>
      </el-form-item>

      <!-- 联系人手机 -->
      <el-form-item label="联系人手机：" prop="contactMobile" :error="errorMsg.contactMobile">
        <el-input
          ref="telInput"
          v-model="ruleForm.contactMobile"
          :disabled="status === 1"
          placeholder="请输入手机号"
          @focus="telFocus"
        ></el-input>
        <div v-show="reasons.contactMobile" class="reason">驳回原因：{{ reasons.contactMobile }}</div>
      </el-form-item>

      <!-- 联系人微信 -->
      <el-form-item label="联系微信：" prop="contactWeixin" :error="errorMsg.contactWeixin">
        <el-input
          v-model="ruleForm.contactWeixin"
          :disabled="status === 1"
          placeholder="请输入微信号或手机号"
          @input="_limitLen(undefined, undefined, 'contactWeixin', 30)"
        ></el-input>
        <div v-show="reasons.contactWeixin" class="reason">驳回原因：{{ reasons.contactWeixin }}</div>
      </el-form-item>

      <!-- 联系人邮箱 -->
      <el-form-item label="联系邮箱：" prop="contactEmail" :error="errorMsg.contactEmail">
        <el-input
          v-model="ruleForm.contactEmail"
          :disabled="status === 1"
          placeholder="请输入邮箱"
          @focus="emailFocus"
        ></el-input>
        <div v-show="reasons.contactEmail" class="reason">驳回原因：{{ reasons.contactEmail }}</div>
      </el-form-item>
      <!-- 联系人证件类型 -->
      <el-form-item label="证件类型">
        <el-select v-model="ruleForm.contactIdCardType" placeholder="" class="input-width">
          <el-option label="居民身份证" :value="1"></el-option>
          <el-option label="其他身份证" :value="6"></el-option>
        </el-select>
      </el-form-item>
      <!-- 联系人身份证号 -->
      <el-form-item
        v-if="!isOverseas"
        :error="errorMsg.contactIdCardNumber"
        label="联系人身份证号："
        prop="contactIdCardNumber"
      >
        <el-input v-model="ruleForm.contactIdCardNumber" :disabled="status === 1" placeholder="请输入联系人身份证号"></el-input>
        <div v-show="reasons.contactIdCardNumber" class="reason">驳回原因：{{ reasons.contactIdCardNumber }}</div>
      </el-form-item>

      <!-- 邀请码 -->
      <el-form-item
        class="code"
        label="邀请码："
        prop="contactInviteCode"
        :error="errorMsg.contactInviteCode"
      >
        <el-input v-model="ruleForm.contactInviteCode" :disabled="status === 1" placeholder="请填写邀请码"></el-input>
        <div v-show="reasons.contactInviteCode" class="reason">驳回原因：{{ reasons.contactInviteCode }}</div>
      </el-form-item>

      <!-- 底部按钮 -->
      <el-form-item class="form-footer">
        <el-button
          v-if="status === 0"
          class="mi-primary"
          :disabled="saveBtnDisabled"
          @click="submitForm('ruleForm')"
        >
          保存并下一步
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 对话框 - 手机验证 -->
    <el-dialog
      title="手机验证"
      width="550px"
      :visible="showTelDialog"
      @close="showTelDialog = false"
    >
      <el-form
        ref="telForm"
        :model="telForm"
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <!-- 联系人手机 -->
        <el-form-item label="联系人手机：" prop="contactMobile">
          <el-input ref="dialogTel" v-model="telForm.contactMobile"></el-input>
        </el-form-item>

        <!-- 验证码： -->
        <el-form-item label="验证码：" prop="verificationCode">
          <el-input v-model="telForm.verificationCode" autocomplete="off"></el-input>
          <img :src="imgCode" alt @click="getImageCode">
        </el-form-item>

        <!-- 短信验证码 -->
        <el-form-item label="短信验证码：" prop="smsCode">
          <el-input v-model="telForm.smsCode" autocomplete="off"></el-input>
          <el-button class="mi-primary-plain" :disabled="buttonMobil.isDisabled" @click="countDown('telForm', 'contactMobile', 'buttonMobil', 60)">
            {{ buttonMobil.buttonName }}
          </el-button>
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" class="mi-info" @click="showTelDialog = false">取 消</el-button>
        <el-button size="mini" class="mi-primary" @click="submitForm('telForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 对话框 - 邮箱验证 -->
    <el-dialog
      title="邮箱验证"
      width="550px"
      :visible="showMailDialog"
      @close="showMailDialog = false"
    >
      <el-form
        ref="emailForm"
        :model="emailForm"
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <!-- 联系人邮箱 -->
        <el-form-item label="联系人邮箱：" prop="contactEmail">
          <el-input ref="dialogEmail" v-model="emailForm.contactEmail"></el-input>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item label="验证码：" prop="emailCode">
          <el-input v-model="emailForm.emailCode" autocomplete="off"></el-input>
          <el-button class="mi-primary-plain" :disabled="buttonEmail.isDisabled" @click="countDown('emailForm', 'contactEmail', 'buttonEmail', 60)">
            {{ buttonEmail.buttonName }}
          </el-button>
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" class="mi-info" @click="showMailDialog = false">取 消</el-button>
        <el-button size="mini" class="mi-primary" @click="submitForm('emailForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
// import contactRules from './rules/contact'
import { isTel } from '@/common/reg'
import { processMixin } from '@/common/mixin'
import { getSMS, getImgCode, getEmailCode, checkImgCode, validateContact, validateOverseaContact } from '@/api/merchant'
import { shallowMerge } from '@/utils'
import contactRules from './rules/contact'

export default {
  mixins: [processMixin],
  props: {
    // 表单状态，0:填写阶段 1:禁止修改 2:可以修改
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    // 联系人表单
    const ruleForm = {
      contactUsername: '',
      contactPosition: '',
      contactMobile: '',
      contactWeixin: '',
      contactEmail: '',
      contactIdCardType: 1,
      contactIdCardNumber: '',
      contactInviteCode: '',
      contactIsInvited: 'N'
    }

    // 手机验证表单
    const telForm = {
      contactMobile: '',
      verificationCode: '',
      smsCode: ''
    }

    // 邮箱验证表单
    const emailForm = {
      contactEmail: '',
      emailCode: ''
    }

    // 表单规则
    const rules = {
      contactUsername: contactRules.contactUsername(),
      contactPosition: contactRules.contactPosition(),
      contactMobile: contactRules.contactMobile(),
      contactWeixin: contactRules.contactWeixin(),
      contactEmail: contactRules.contactEmail(),
      contactIdCardType: contactRules.contactIdCardType(),
      contactIdCardNumber: contactRules.contactIdCardNumber(ruleForm),
      contactInviteCode: contactRules.contactInviteCode(),
      verificationCode: contactRules.verificationCode(this.checkImageCode),
      smsCode: contactRules.smsCode(telForm),
      emailCode: contactRules.emailCode(emailForm)
    }

    return {
      ruleForm,
      telForm,
      emailForm,
      rules,
      imgCode: '',
      saveBtnDisabled: false,
      imgCodePass: false,
      buttonMobil: {
        time: 10,
        buttonName: '获取短信验证码',
        isDisabled: false
      },
      buttonEmail: {
        time: 10,
        buttonName: '获取邮箱验证码',
        isDisabled: false
      },
      formLabelWidth: '120px',
      showTelDialog: false,
      showMailDialog: false,
      errorMsg: {
        contactUsername: null,
        contactPosition: null,
        contactMobile: null,
        contactWeixin: null,
        contactEmail: null,
        contactIdCardNumber: null,
        contactInviteCode: null
      },
      reasons: {
        contactUsername: null,
        contactPosition: null,
        contactMobile: null,
        contactWeixin: null,
        contactEmail: null,
        contactIdCardNumber: null,
        contactInviteCode: null
      }
    }
  },

  computed: {
    ...mapState({
      merchantData: state => state.merchantData,
      isOverseas: state => state.isOverseas
    })
  },

  mounted() {
    if (this.merchantData && this.merchantData.contact) {
      const data = this.merchantData.contact
      for (let k in data) {
        if (k in this.ruleForm) this.ruleForm[k] = data[k]
      }
    }
  },

  methods: {
    ...mapMutations({
      setContactIndex: 'SET_CONTACT_INDEX',
      setStepIndex: 'SET_STEP_INDEX',
      setMerchantData: 'SET_MERCHANT_DATA'
    }),
    /**
     * @name telFocus
     * @description 打开手机验证对话框
     */
    telFocus() {
      this.showTelDialog = true
      this.telForm.contactMobile = this.ruleForm.contactMobile
      this.getImageCode()
      this.$nextTick(() => {
        this.$refs.dialogTel.$el.children[0].focus()
      })
    },
    /**
     * @name 打开邮箱验证对话框
     * @description emailFocus
     */
    emailFocus() {
      this.showMailDialog = true
      this.emailForm.contactEmail = this.ruleForm.contactEmail
      this.$nextTick(() => {
        this.$refs.dialogEmail.$el.children[0].focus()
      })
    },
    /**
     * @name assignTel
     * @description 手机号赋值
     */
    assignTel() {
      this.ruleForm.contactMobile = this.telForm.contactMobile
      this.$refs.ruleForm.validateField(['contactMobile'])
      this.showTelDialog = false
    },
    /**
     * @name assignEmail
     * @description 邮箱赋值
     */
    assignEmail() {
      this.ruleForm.contactEmail = this.emailForm.contactEmail
      this.$refs.ruleForm.validateField(['contactEmail'])
      this.showMailDialog = false
    },
    /**
     * @name getMobileCode
     * @description 获取手机验证码
     * @param {string} key
     */
    async getMobileCode(key) {
      try {
        if (isTel.test(this.telForm.contactMobile)) {
          const info = await getSMS({ mobile: this.telForm.contactMobile })
          if (!info.code) return info
          this[key].time = 0
          return this.$message.error(`${info.msg}`)
        } else {
          this[key].time = 0
          this.$message.error('请正确填写手机号')
        }
      } catch (e) {
        this[key].time = 0
        throw Error(e)
      }
    },
    getImageCode() {
      this.imgCode = getImgCode()
      this.imgCodePass = false
    },
    /**
     * @name checkImageCode
     * @description 验证图形验证码
     */
    async checkImageCode(value, callback) {
      try {
        const info = await checkImgCode({
          code: this.telForm.verificationCode
        })
        const { code, msg } = info
        if (value && callback) {
          if (!code) {
            this.imgCodePass = true
            callback && callback()
          } else {
            this.getImageCode()
            return callback(new Error(msg))
          }
        }
        return info
      } catch (e) {
        throw Error(e)
      }
    },
    /**
     * @name emailCode
     * @description 获取邮箱验证码
     * @param {string} key
     */
    async emailCode(key) {
      try {
        return await getEmailCode({ email: this.emailForm.contactEmail })
      } catch (e) {
        this[key].time = 0
        throw Error(e)
      }
    },
    /**
     * @name countDown
     * @description 验证码倒计时
     */
    countDown(formName, validKey, key, time) {
      setTimeout(() => {
        this.$refs[formName].validateField([validKey], async error => {
          if (!error) {
            switch (validKey) {
              case 'contactMobile':
                if (this.telForm.verificationCode) {
                  if (this.imgCodePass) this.getMobileCode(key)
                  else return this.$message.error('请重试')
                } else return this.$message.error('请填写图形验证码')
                break
              case 'contactEmail':
                this.emailCode(key)
                break
              default:
                this.getMobileCode(key)
            }

            this[key].time = time
            this[key].isDisabled = true
            let interval = setInterval(() => {
              this[key].time--
              this[key].buttonName = `${this[key].time}s 后重新发送`
              if (this[key].time <= 0) {
                this[key].buttonName = '重新发送'
                this[key].time = time
                this[key].isDisabled = false
                clearInterval(interval)
              }
            }, 1000)
          }
        })
      }, 500)
    },
    /**
     * @name submitForm
     * @description 提交表单
     */
    submitForm(formName, jump = true) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            switch (formName) {
              case 'telForm':
                this.assignTel()
                break
              case 'emailForm':
                this.assignEmail()
                break
              default:
                this.setMerchantData(shallowMerge({ contact: this.ruleForm }, this.merchantData))
                this.saveBtnDisabled = true
                if (!(await this.validateContact())) {
                  this.saveBtnDisabled = false
                  reject()
                  return false
                } else {
                  this.saveBtnDisabled = false
                  if (jump) this.setContactIndex(1)
                  resolve()
                }
            }
          } else {
            return false
          }
        })
      })
    },
    /**
     * @name validateContact
     * @description 校验联系信息
     */
    async validateContact() {
      const result = !this.isOverseas
        ? (await validateContact(this.ruleForm))
        : (await validateOverseaContact(this.ruleForm))
      if (result.code !== 0) {
        if (result.data && result.data.fields) {
          const errorFields = result.data.fields
          for (let field in errorFields) {
            if (this.errorMsg.hasOwnProperty(field)) {
              this.errorMsg[field] = errorFields[field]
            }
          }
        }
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less">
.contact-form {
  .el-dialog {
    .el-form-item {
      .el-input {
        width: 150px !important;
      }
      &:nth-of-type(1) {
        .el-input {
          width: 300px !important;
        }
      }
      .el-button,
      img {
        width: 140px !important;
        margin-left: 10px;
      }

      img {
        vertical-align: bottom;
      }
    }
  }

  .el-icon-document {
    text-decoration: underline;
  }

  .reason {
    font-size: 13px;
    line-height: 16px;
    color: #E00C0C;
    padding: 10px 0 0 10px;
  }
}
</style>
